import React from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { IListingIssueDetails } from "../../../commonTypes";
import {
  TrackSubtitle,
  TrackSubtitleContainer,
  TrackTitle,
} from "../sharedStyles";

const Root = styled.div``;

type Props = {
  title: string;
  price: string;
  currency: string;
  issueDetails?: IListingIssueDetails;
};
const AuctionTitle = ({ title, price, currency, issueDetails }: Props) => {
  const { t } = useTranslation();
  return (
    <Root>
      <TrackTitle>{title}</TrackTitle>
      <TrackSubtitleContainer>
        <TrackSubtitle>
          {t("auction-price")} {price} {currency}
        </TrackSubtitle>
        <TrackSubtitle>
          {issueDetails &&
            `${issueDetails.issueNumber} of ${issueDetails.totalIssues}`}
        </TrackSubtitle>
      </TrackSubtitleContainer>
    </Root>
  );
};

export default AuctionTitle;
